/**
 * Configuración de la aplicación.
 *
 * El NOMBRE no está aquí: vive en `app.config.ts`, en la raíz del frontend, porque lo
 * necesita también `vite.config.ts` (manifest de la PWA) y ese se ejecuta en Node.
 * Se reexporta desde aquí para que los componentes solo tengan que conocer un módulo.
 */
export { APP_NAME, APP_SHORT_NAME, APP_DESCRIPTION } from '../app.config.ts';

/**
 * Raíz de la API. En desarrollo el proxy de Vite reenvía /api al backend en :3000, así
 * que el navegador ve MISMO ORIGEN: sin CORS y con la cookie de sesión viajando sola.
 * En producción nginx sirve la PWA y hace el mismo reenvío, así que la ruta no cambia.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api';

/**
 * Idioma por defecto y único activo. Añadir español en el futuro es añadir 'es' aquí y
 * un archivo en src/i18n/locales/, sin tocar ninguna pantalla.
 */
export const DEFAULT_LOCALE = 'fr';
export const SUPPORTED_LOCALES = ['fr'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/** Reglas del formulario. Son las MISMAS que aplica el backend, no otras más laxas. */
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 128;
export const USERNAME_PATTERN = /^[A-Za-z0-9_.-]{3,24}$/;

/**
 * Código de invitación. El alfabeto excluye 0, 1, I, L y O a propósito, para que se
 * pueda dictar por teléfono sin confusiones (misma restricción que la base de datos:
 * `leagues_invite_code_format`).
 */
export const INVITE_CODE_LENGTH = 8;
export const INVITE_CODE_PATTERN = /^[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{8}$/;

/** Tope de marcador, el mismo que la restricción `predictions_scores_in_range`. */
export const SCORE_MIN = 0;
export const SCORE_MAX = 200;

/**
 * Ventana del recap post-jornada, en días. El backend la acepta como parámetro y usa
 * este mismo valor por defecto (`RECAP_DIAS_POR_DEFECTO` en recap.schemas.ts): se manda
 * explícita para que el día que se cambie no dependa de que las dos coincidan de memoria.
 */
export const RECAP_DIAS_POR_DEFECTO = 7;

/**
 * Versión de la política de privacidad que se acepta al registrarse (RGPD).
 * Tiene que coincidir con PRIVACY_POLICY_VERSION del backend (auth.schemas.ts).
 */
export const PRIVACY_POLICY_VERSION = '2026-08-01';
